<template>
    <EditorField
        v-model="introduction"
        :name="`${namePrefix}_introduction`"
        label="campaign_marketing_financial_introduction"
        help="help_campaign_marketing_financial_introduction"
        variant="minimal"
    />
    <div class="mt-8 flex h-auto w-full flex-col gap-4">
        <CampaignContentTableEditor
            v-for="(table, index) in tables"
            :key="table.id"
            v-model="tables[index]"
            :name-prefix="`${namePrefix}_${index}`"
            :index="index"
            @remove="removeTable(index)"
        />
        <div class="flex h-auto w-full items-center justify-end">
            <button
                class="h-auto w-auto rounded-md bg-blue-500 px-4 py-2 text-sm font-medium text-white"
                @click="addTable"
            >
                {{ $t('campaign_marketing_financial_add_table') }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import EditorField from '@src/components/EditorField.vue'
import { FinancialTable } from '@src/types'
import { generateUuid } from '@src/utils/helpers'
import { useVModels } from '@vueuse/core'
import CampaignContentTableEditor from './CampaignContentTableEditor.vue'

const props = defineProps<{
    introduction: string | null
    tables: FinancialTable[]
    namePrefix: string
}>()

const emit = defineEmits<{
    (e: 'update:introduction', value: string | null): void
    (e: 'update:tables', value: FinancialTable[]): void
}>()

const { introduction, tables } = useVModels(props, emit)

const addTable = () => {
    tables.value = [
        ...(tables.value ?? []),
        {
            id: generateUuid(),
            title: '',
            periods: [],
            rows: [],
            note: null,
        },
    ]
}

const removeTable = (index: number) => {
    tables.value?.splice(index, 1)
}
</script>
